import { DEFAULT_COLOR_SET } from "../constants/networkEnums";

let initialState = {
  loader: true,
  deepDiveData: null,
  authorPostDetailsLoader: true,
  authorPostDetailsData: null,
  defaultColorSetIndex: 0,
  networkCommonEdgesColor: DEFAULT_COLOR_SET?.[0]?.[2]?.value,
  networkEdgesHighlightColor: DEFAULT_COLOR_SET?.[0]?.[3]?.value,
  isNetworkWidgetSettingEdit: false,
  widgetSettingObj: null,
};
// These are using for Netwok Chart
const Network = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_NETWORK":
      return {
        ...initialState,
      };
    case "SET_DEEPDIVE_LOADER":
      return {
        ...state,
        loader: action?.loader,
      };
    case "SET_DEEPDIVE_DATA":
      return {
        ...state,
        deepDiveData: action?.deepDiveData,
      };
    case "SET_AUTHOR_POST_DETAILS_LOADER":
      return {
        ...state,
        authorPostDetailsLoader: action?.loader,
      };
    case "SET_AUTHOR_POST_DETAILS_DATA":
      return {
        ...state,
        authorPostDetailsData: action?.authorPostDetailsData,
      };
    case "SET_NETWORK_COMMON_EDGES_COLOR":
      return {
        ...state,
        networkCommonEdgesColor: action?.commonEdgesColor,
      };
    case "SET_NETWORK_HIGHLIGHT_EDGES_COLOR":
      return {
        ...state,
        networkEdgesHighlightColor: action?.edgesHighlightColor,
      };
    case "SET_DEFAULT_COLOR_SET_INDEX_FOR_NETWORK":
      return {
        ...state,
        defaultColorSetIndex: action?.defaultColorSetIndex,
      };
    case "SET_IS_NETWORK_WIDGET_SETTING_EDIT":
      return {
        ...state,
        isNetworkWidgetSettingEdit: action?.value,
      };
    case "SET_NETWORK_WIDGET_SETTING_OBJECT":
      return {
        ...state,
        widgetSettingObj: action?.value,
      };

    default:
      return state;
  }
};

export default Network;
